export const FETCH_BANNERS_REQUEST = 'FETCH_BANNERS_REQUEST'
export const FETCH_BANNERS_SUCCES = 'FETCH_BANNERS_SUCCES'
export const FETCH_BANNERS_ERROR = 'FETCH_BANNERS_ERROR'



// WEBPACK FOOTER //
// ./src/constants/Banners.js